module.exports = __webpack_public_path__ + "media/Team/Scott-6e866ca4.jpeg";